module.exports = __webpack_public_path__ + "img/744.a8a766f0.jpg";